import React from "react"

interface LoadingIndicatorProps {
  text?: string
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ text = "Loading..." }) => {
  return (
    <div className="flex items-center justify-center py-8">
      <div className="animate-spin h-8 w-8 border-4 border-purple-500 rounded-full border-t-transparent"></div>
      <span className="ml-3 text-gray-400">{text}</span>
    </div>
  )
}
